import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet, fnSave, fnGetTableById } from "@shared/api/restApi";
import {
  getInitPopUp,
  getTablebySql,
  getInitPopUpData,
} from "@shared/utils/CommonUtils";
import { showDialog } from "@widgets/CommonDialog";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import SnTabHeader from "@shared/components/SnTabHeader";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";
import SnSearchBtn from "@shared/components/SnSearchBtn";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}
interface RowData {
  KeyField?: string;

  [key: string]: any;
}
const SN_PRD_WRK_REG_002_TEX_POP_003 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    //#region variable
    const { userInfo } = global();
    const [gridFocus, setGridFocus] = useState(false);
    const [popupParent, setPopupParent] = useState<any>(null);
    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const searchRef = useRef<any>(null);
    const cd_wh = useRef<any>(null);
    const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
      grid1: React.createRef(),
      grid2: React.createRef(),
    });
    const [columns, setColums] = useState<any>({
      grid1: [],
      grid2: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
      grid2: [],
    });
    useImperativeHandle(ref, () => ({
      checkValidity: async () => {
        const searchData = searchRef.current.getFormdata();
        let lsChk: any = "2";
        if (searchData.cd_wh === "" || searchData.cd_wh === null) {
          lsChk = "1";
        } else {
          lsChk = "2";
        }

        if (lsChk === "1") {
          return { flag: false, message: "창고는 필수값 입니다." };
        }
        return { flag: true };
      },
      getSelectedValue: async () => {
        onSave();
      },
      getSelectedRow: () => [true],
    }));
    //#endregion
    useEffect(() => {
      if (modalRef?.current) {
        setPopupParent(modalRef.current.getPopupParent());
      }
    }, [modalRef?.current]);
    useEffect(() => {
      const fetchform = async () => {
        try {
          //getinitformdata식으로 바껴야함
          const rtn: any = await getInitPopUpData(
            "SN_PRD_WRK_REG_002_TEX_POP_003",
            {}
          );
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormData(mergedData); // 조회조건 초기값
          setFormControlData(rtn.formControlData); // 조회조건 항목 설정
          setColums({
            grid1: rtn.grid.grid1,
            grid2: rtn.grid.grid2,
          });
        } catch (error: any) {}
      };
      fetchform();
    }, []);

    useEffect(() => {
      gridRefs.current["grid1"].current.selectAndFocusRow(0);
      setGridFocus(false);
    }, [gridFocus]);

    const onInsert = () => {
      try {
        const newRow = {};
        gridRefs.current["grid1"].current?.addRow(newRow);
      } catch (error: any) {
        showDialog("error", error.message);
      }
    };
    //#region Button Event
    const onSearch = () => {
      const fetchdatasource = async () => {
        try {
          const searchData = searchRef.current.getFormdata();
          const params = {
            id: "sn_prd_wrk_reg_003_tex_pop_01",
            params: {
              cd_firm: userInfo.cd_firm,
              no_po: searchData.no_po,
              no_wo: selectedData.no_wo,
              cd_wh: searchData.cd_wh,
              no_style: selectedData.no_style,
              qt_work: selectedData.qt_work,
              dt_io: selectedData.dt_io,
              cd_biz: selectedData.cd_biz,
              no_io: selectedData.no_io,
            },
          };

          const data: any = await fnGetDataSet(params);
          setDataSources({
            grid1: data[0],
            grid2: data[1] || [],
          });
          if (data[0] && data[0].length > 0) {
            await new Promise((resolve) => setTimeout(resolve, 50));

            setGridFocus(true);
            gridRefs.current["grid1"].current.resetUpdate();
            gridRefs.current["grid2"].current.resetUpdate();
          } else {
            await onInsert();
          }
        } catch (error: any) {
          showDialog("error", error.message);
        }
      };
      fetchdatasource();
    };
    const onSave = async () => {
      gridRefs.current["grid1"].current?.stopEditing();
      gridRefs.current["grid2"].current?.stopEditing();
      const searchData = searchRef.current.getFormdata();

      const grid = gridRefs.current["grid1"].current?.getCheckedRows();
      const grid2 = gridRefs.current["grid2"].current?.getCheckedRows();

      const mtlQtiohInserts: any[] = [];
      mtlQtiohInserts.push({
        cd_firm: userInfo.cd_firm,
        no_io: selectedData.no_io,
        cd_biz: userInfo.cd_biz,
        cd_wh: searchData.cd_wh,
        dt_io: selectedData.dt_io,
        cd_io: "310",
        fg_slip: "2",
        tp_slip: "3",
        fg_io: "1",
        fg_money: "1",
        fg_trns: null,
        yn_autoprocess: "Y",
        cd_dept: userInfo.cd_dept,
        cd_emp: userInfo.cd_emp,
        cd_gp: userInfo.cd_gp,
        fg_map: "1",
        yn_send: "N",
      });
      const mtlQtiohChanges = {
        insert: mtlQtiohInserts,
        update: [],
        delete: [],
        modifiedRowcount: mtlQtiohInserts.length,
      };

      const checkedRows = gridRefs.current["grid1"].current?.getCheckedRows();

      const mtlQtioTexChanges = {
        insert: checkedRows,
        update: [],
        delete: [],
        modifiedRowcount: checkedRows.length,
      };
      const checkedRows2 = gridRefs.current["grid2"].current?.getCheckedRows();

      const mtlQtioChanges = {
        insert: checkedRows2,
        update: [],
        delete: [],
        modifiedRowcount: checkedRows2.length,
      };

      const payload = {
        id: "wo_tex_update_yn_isu",
        params: {
          cd_firm: userInfo.cd_firm,
          no_wo: selectedData.no_wo,
          yn_isu: searchData.yn_isu,
        },
      };
      await fnGetTableById(payload);
      const SaveData = {
        mtl_qtioh: mtlQtiohChanges,
        mtl_qtio: mtlQtioChanges,
        mtl_qtio_tex: mtlQtioTexChanges,
      };
      await fnSave("SN_PRD_WRK_REG_002_TEX_SAVE_03_POP", SaveData);

      return true;
    };
    //#endregion

    const onCellValueChanged = async (event: CellValueChangedEvent) => {
      if (!event) return;
      const colId = event.colId;
      const rowData = event.rowData;
      const rowNode = event.rowNode;
      if (colId === "stock_qt") {
        rowNode.setDataValue(
          "use_qt",
          rowData.qt_w - rowData.stock_qt,
          "noEvent"
        );
      } else if (colId === "stock_qt_divide") {
        rowNode.setDataValue(
          "use_qt_divide",
          rowData.qt_divide_w - rowData.stock_qt_divide,
          "noEvent"
        );
      } else if (colId === "use_qt") {
        rowNode.setDataValue(
          "stock_qt",
          rowData.qt_w - rowData.use_qt,
          "noEvent"
        );
      } else if (colId === "use_qt_divide") {
        rowNode.setDataValue(
          "stock_qt_divide",
          rowData.qt_divide_w - rowData.use_qt_divide,
          "noEvent"
        );
      }
    };
    const onFocusedRowChanged = async (event: any) => {
      const selectedRow = event;
      gridRefs.current["grid2"].current.applyFilters({
        no_work: selectedRow.no_work,
      });
      gridRefs.current["grid2"].current.selectAndFocusRow(0);
    };
    const setFooterDataToRow = () => {
      setTimeout(() => {
        const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
        const footerData = gridRefs.current["grid2"].current.getFooterData();
        if (focusedNodeH) {
          focusedNodeH.setDataValue("qt_b", footerData.qt_b);
        }
      }, 0);
    };
    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
          events: {
            onFocusedRowChanged,
            onCellValueChanged: onCellValueChanged,
          },
        },
        grid2: {
          columns: columns.grid2,
          dataSource: dataSources.grid2,
          events: {
            onCellValueChanged: onCellValueChanged,
          },
        },
      }),
      [columns, dataSources]
    );
    return (
      <div className="h-full flex flex-col">
        <div className="mb-1">
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
          />
        </div>
        <div style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{ width: 80, marginTop: 1.5 }}
            spinner={true}
          />
        </div>

        <div>
          <div style={{ height: "29vh", marginTop: "10px" }}>
            <SnGrid
              ref={gridRefs.current["grid1"]}
              columnConfig={grids.grid1.columns}
              rowData={grids.grid1.dataSource}
              etcProps={{
                title: "원단",
                rowSelection: "single",
                ischeckboxSelection: true,
              }}
              events={grids.grid1.events}
            />
          </div>
          <div style={{ height: "29vh", marginTop: "10px" }}>
            <div className="h-full">
              <SnGrid
                ref={gridRefs.current["grid2"]}
                columnConfig={grids.grid2.columns}
                rowData={grids.grid2.dataSource}
                etcProps={{
                  title: "기타",
                  rowSelection: "multiple",
                  ischeckboxSelection: true,
                }}
                events={grids.grid2.events}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default SN_PRD_WRK_REG_002_TEX_POP_003;
